import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { TARGET_KIND_LABEL } from '../outreachLabels';
import { FIND_KINDS, type SearchableTargetKind } from './findKinds';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface FindTabsProps {
  kind: SearchableTargetKind;
  onChange: (kind: SearchableTargetKind) => void;
}

/** The kinds of Find (design outreach c1, c3): playlists, blogs, newsletters, radio, podcasts, creators. */
const FindTabsComponent: React.FC<FindTabsProps> = ({ kind, onChange }) => {
  const intl = useIntl();
  const tabs = useMemo(
    () =>
      FIND_KINDS.map((item) => (
        <button
          key={item}
          type="button"
          role="tab"
          aria-selected={item === kind}
          className={clsx(styles.tab, item === kind && styles.tabOn)}
          onClick={() => onChange(item)}
          data-testid={`find-tab-${item}`}
        >
          {intl.formatMessage(TARGET_KIND_LABEL[item])}
        </button>
      )),
    [intl, kind, onChange]
  );
  return (
    <div className={styles.tabs} role="tablist">
      {tabs}
    </div>
  );
};

export const FindTabs = TypedMemo(FindTabsComponent);
